// extracted by mini-css-extract-plugin
module.exports = {"stats-section":"TrustStats_stats-section__l2p3p","stat-item":"TrustStats_stat-item__omDda","icon-wrapper":"TrustStats_icon-wrapper__1ev5K"};